<template>
  <div class="landing-page">
    <section class="" v-if="data_check('0', ['image', 'title', 'description'])">
      <div class="section align-items-stretch display-div-reverse">
        <div class="left bg-old-gold">
          <div class="float-right top-section-left-inner pr-30">
            <div class="landing-page-logo" v-if="data_check('0', ['logo'])">
              <img :src="dataSetImage(data_get('0', 'logo'))" alt="">
            </div>
            <h1 class="landing-page-title">{{ data_get('0', 'title') }}</h1>
            <div v-html="data_get('0', 'description')"></div>
          </div>
        </div>
        <div class="right">
          <div class="landing-page-right-image">
            <img :src="dataSetImage(data_get('0', 'image'))" alt="">
          </div>
        </div>
      </div>
    </section>

    <section class="section-space" v-if="data_check('17', ['data'])">
      <div class="container">
        <div class="another-stats text-center">
          <a v-for="(s17_item, s17_k) in JSON.parse(data_get('17', 'data'))" :key="s17_k" :href="s17_item.link" class="another-stat" target="_blank">
            <div class="image-container">
              <img :src="`${campaign.image_base_path}${s17_item.image}`" alt="">
              <h3>{{s17_item.title}}</h3>
            </div>
          </a>
        </div>
      </div>
    </section>

    <section class="section-space py-5" v-if="data_check('1', ['data'])" :style="[data_get('1', 'background_color') ? {backgroundColor : data_get('1', 'background_color')} : {}]">
      <div class="container">
        <div class="stats text-center">
          <div class="stat" v-for="(s1_item, s1_k) in JSON.parse(data_get('1', 'data'))" :key="s1_k">
            <img :src="`${campaign.image_base_path}${s1_item.image}`" alt="">
            <h3 :style="[data_get('1', 'background_color') ? {'color' : '#fff !important'} : {}]">{{s1_item.title}}</h3>
            <p :style="[data_get('1', 'background_color') ? {'color' : '#fff !important'} : {}]">{{s1_item.description}}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section-space" v-if="data_check('2', ['title', 'description'])">
      <div class="container">
        <div class="section">
          <div class="left py-2">
            <h2 class="landing-page-title-default">{{ data_get('2', 'title')}}</h2>
          </div>
          <div class="right py-2 pl-30">
            <div v-html="data_get('2', 'description')"></div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-space" v-if="data_check('3', ['image', 'title', 'description'])">
      <div class="container">
        <div class="section align-items-center">
          <div class="left py-2">
            <div class="section-4-img-container">
              <img :src="`${campaign.image_base_path}${data_get('3', 'image')}`">
            </div>
          </div>
          <div class="right py-2 pl-30">
            <h2 class="landing-page-title-content">
              {{ data_get('3', 'title') }}
            </h2>
            <div v-html="data_get('3', 'description')"></div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-space" v-if="data_check('4', ['image', 'button_one_title', 'button_two_title', 'title'])">
      <div class="container">
        <div class="section align-items-center section-background-image p-5 section-border-radius" :style="dataSetStyle(data_get('4', 'image'))">
          <div class="left p-2">
            <h3 class="color-white font-size-44">{{ data_get('4', 'title') }}</h3>
          </div>
          <div class="right p-2">
            <div class="d-flex flex-column button-container">
              <div class="text-center">
                <a :href="data_get('4', 'button_one_link')" class="landing-page-button-primary">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path
                        d="M497.4 361.8l-112-48a24 24 0 0 0 -28 6.9l-49.6 60.6A370.7 370.7 0 0 1 130.6 204.1l60.6-49.6a23.9 23.9 0 0 0 6.9-28l-48-112A24.2 24.2 0 0 0 122.6 .6l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.3 24.3 0 0 0 -14-27.6z"/>
                  </svg>
                  {{ data_get('4', 'button_one_title') }}
                </a>
              </div>
              <div class="text-center">
                <a :href="data_get('4', 'button_two_link')" class="landing-page-button-secondary">
                  {{ data_get('4', 'button_two_title') }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-space" v-if="data_check('5', ['title', 'description'])">
      <div class="container">
        <div class="section align-items-start">
          <div class="w-30">
            <h2 class="landing-page-title-default">{{ data_get('5', 'title') }}</h2>
          </div>
          <div class="w-70 pl-3">
            <div v-html="data_get('5', 'description')"></div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-space" v-if="data_check('6', ['image', 'title', 'description'])">
      <div class="container">
        <div class="section align-items-center display-div-reverse align-items-md-start">
          <div class="left py-2">
            <div class="section-4-img-container">
              <img :src="dataSetImage(data_get('6', 'image'))">
            </div>
          </div>
          <div class="right py-2 pl-30">
            <h2 class="landing-page-title-content">{{data_get('6', 'title')}}</h2>
            <div v-html="data_get('6', 'description')"></div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-space" v-if="data_check('7', ['image', 'button_one_title', 'button_two_title', 'title'])">
      <div class="container">
        <div class="section align-items-center section-background-image p-5 section-border-radius" :style="dataSetStyle(data_get('7', 'image'))">
          <div class="left p-2">
            <h3 class="color-white font-size-44">{{ data_get('7', 'title') }}</h3>
          </div>
          <div class="right p-2">
            <div class="d-flex flex-column button-container">
              <div class="text-center">
                <a :href="data_get('7', 'button_one_link')" class="landing-page-button-primary">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path
                        d="M497.4 361.8l-112-48a24 24 0 0 0 -28 6.9l-49.6 60.6A370.7 370.7 0 0 1 130.6 204.1l60.6-49.6a23.9 23.9 0 0 0 6.9-28l-48-112A24.2 24.2 0 0 0 122.6 .6l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.3 24.3 0 0 0 -14-27.6z"/>
                  </svg>
                  {{ data_get('7', 'button_one_title') }}
                </a>
              </div>
              <div class="text-center">
                <a :href="data_get('7', 'button_two_link')" class="landing-page-button-secondary">
                  {{ data_get('7', 'button_two_title') }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-space" v-if="data_check('8', ['image', 'title', 'description'])">
      <div class="container">
        <div class="section align-items-stretch display-div-reverse">
          <div class="left p-lg-5 p-3 bg-off-white border-top-left-radius border-bottom-left-radius">
            <div class="lp-widget-container mb-4" v-if="data_check('8', ['small_image'])">
              <img :src="dataSetImage(data_get('8', 'small_image'))">
            </div>
            <h2 class="landing-page-title-default">{{data_get('8', 'title')}}</h2>
            <div class="mt-4" v-html="data_get('8', 'description')">

            </div>
<!--            <div class="mt-4">
              <a href="javascript:void(0)" class="landing-page-button-default">Ota yhteyttä</a>
            </div>-->
          </div>
          <div class="right">
            <div class="section-image-container">
              <img :src="dataSetImage(data_get('8', 'image'))" class="border-top-right-radius border-bottom-right-radius">
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-space" v-if="data_check('9', ['image', 'title', 'description'])">
      <div class="container">
        <div class="section align-items-center display-div-reverse">
          <div class="left p-lg-5 p-3">
            <h2 class="landing-page-title-default">{{ data_get('9', 'title') }}</h2>
            <div class="mt-4" v-html="data_get('9', 'description')">

            </div>
<!--            <div class="mt-4">
              <a href="javascript:void(0)" class="landing-page-button-default">Ota yhteyttä</a>
            </div>-->
          </div>
          <div class="right">
            <div class="section-image-container">
              <img :src="dataSetImage(data_get('9', 'image'))">
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-space" v-if="data_check('10', ['title', 'description'])">
      <div class="container">
        <div class="section">
          <div class="left py-2">
            <h2 class="landing-page-title-default">{{ data_get('10', 'title') }}</h2>
          </div>
          <div class="right py-2 pl-30">
            <div v-html="data_get('10', 'description')"></div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-space" v-if="data_check('11', ['image', 'title', 'description', 'youtube_link'])">
      <div class="container">
        <div class="section align-items-stretch display-div-reverse">
          <div class="left p-lg-5 p-3 bg-off-white">
            <div class="landing-page-logo" v-if="data_check('11', ['small_image'])">
              <img :src="dataSetImage(data_get('11', 'small_image'))" alt="">
            </div>
            <h2 class="landing-page-title-default">{{data_get('11', 'title')}}</h2>
            <div class="mt-4" v-html="data_get('11', 'description')"></div>
<!--            <div class="mt-4">
              <a href="javascript:void(0)" class="landing-page-button-default">Tutustu asiakastarinoihin</a>
            </div>-->
          </div>
          <div class="right">
            <div class="thumbnail-container" v-if="!videoVisible" @click="playVideo()">
              <img :src="dataSetImage(data_get('11', 'image'))" alt="Video Thumbnail" class="thumbnail-image">
              <div class="play-button" id="playButton">
                <i class="fas fa-play"></i>
              </div>
            </div>
            <div class="video-container" v-if="videoVisible">
              <div class="iframe-container">
                <iframe
                    :src="data_get('11', 'youtube_link')"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen>
                </iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-space" v-if="data_check('12', ['image', 'button_one_title', 'button_two_title', 'title'])">
      <div class="container">
        <div class="section align-items-center section-background-image p-5 section-border-radius" :style="dataSetStyle(data_get('12', 'image'))">
          <div class="left p-2">
            <h3 class="color-white font-size-44">{{ data_get('12', 'title') }}</h3>
          </div>
          <div class="right p-2">
            <div class="d-flex flex-column button-container">
              <div class="text-center">
                <a :href="data_get('12', 'button_one_link')" class="landing-page-button-primary">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path
                        d="M497.4 361.8l-112-48a24 24 0 0 0 -28 6.9l-49.6 60.6A370.7 370.7 0 0 1 130.6 204.1l60.6-49.6a23.9 23.9 0 0 0 6.9-28l-48-112A24.2 24.2 0 0 0 122.6 .6l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.3 24.3 0 0 0 -14-27.6z"/>
                  </svg>
                  {{ data_get('12', 'button_one_title') }}
                </a>
              </div>
              <div class="text-center">
                <a :href="data_get('12', 'button_two_link')" class="landing-page-button-secondary">
                  {{ data_get('12', 'button_two_title') }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-space" v-if="data_check('13', ['title', 'data'])">
      <div class="container">
        <div class="align-items-stretch">
          <h2 class="landing-page-title-default">{{ data_get('13', 'title') }}</h2>

          <div class="blog-container">
            <div v-for="(blog, index) in JSON.parse(data_get('13', 'data'))" :key="blog.id" class="blog-item">
              <div class="blog-number">{{ formatNumber(index + 1) }}.</div>
              <p class="blog-description">{{ blog.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-space" v-if="data_check('14', ['image', 'title', 'description'])">
      <div class="container">
        <div class="section align-items-center">
          <div class="left">
            <div class="section-image-container">
              <img :src="dataSetImage(data_get('14', 'image'))" class="border-top-left-radius border-bottom-left-radius">
            </div>
          </div>
          <div class="right pl-30 py-2">
            <h2 class="landing-page-title-default">{{ data_get('14', 'title') }}</h2>
            <div v-html="data_get('14', 'description')"></div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-space" v-if="data_check('15', ['image', 'button_one_title', 'button_two_title', 'title'])">
      <div class="container">
        <div class="section align-items-center section-background-image p-5 section-border-radius" :style="dataSetStyle(data_get('15', 'image'))">
          <div class="left p-5">
            <h2 class="color-white font-size-44">{{ data_get('15', 'title') }}</h2>
          </div>
          <div class="right p-2">
            <div class="d-flex flex-column button-container">
              <div class="color-white" v-html="data_get('15', 'description')"></div>

              <div class="text-left text-md-center">
                <a :href="data_get('15', 'button_one_link')" class="landing-page-button-primary">
                  {{ data_get('15', 'button_one_title') }}
                </a>
              </div>
              <div class="text-left text-md-center">
                <a :href="data_get('15', 'button_two_link')" class="landing-page-button-secondary">
                  {{ data_get('15', 'button_two_title') }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-space" v-if="data_check('16', ['title', 'data'])">
      <div class="container">
        <div class="section align-items-start">
          <div class="w-50">
            <h2 class="landing-page-title-default">{{ data_get('16', 'title') }}</h2>
          </div>
          <div class="w-50">
            <b-card no-body class="accordion-card" v-for="(item, index) in JSON.parse(data_get('16', 'data'))" :key="index">
              <b-card-header header-tag="header" class="accordion-header" @click="toggleAccordion(index)">
                {{ item.title }}
                <span class="accordion-icon" v-if="!isOpen(index)"><i class="fa fa-plus"></i></span>
                <span class="accordion-icon" v-else><i class="fa fa-minus"></i></span>
              </b-card-header>
              <b-collapse :id="'accordion-' + index" accordion="my-accordion" :visible="isOpen(index)">
                <b-card-body v-html="item.description"></b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>
      </div>
    </section>
  </div>

</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "LandingPage",
  data() {
    return {
      videoVisible: false,
      openIndex: null,
      sections : {
        '0':'top_section_trans',
        '1':'section_one_trans',
        '2':'section_two_trans',
        '3':'section_three_trans',
        '4':'section_four_trans',
        '5':'section_five_trans',
        '6':'section_six_trans',
        '7':'section_seven_trans',
        '8':'section_eight_trans',
        '9':'section_nine_trans',
        '10':'section_ten_trans',
        '11':'section_eleven_trans',
        '12':'section_twelve_trans',
        '13':'section_thirteen_trans',
        '14':'section_fourteen_trans',
        '15':'section_fifteen_trans',
        '16':'section_sixteen_trans',
        '17':'section_image_trans'
      }
    };
  },
  computed : {
    ...mapGetters("campaign", ["campaign"]),
    ...mapGetters("app", ["currentLang"])
  },
  async mounted() {
    var slug = this.$route.params.slug;
    var lang = this.$route.name === 'campaign_en' ? 'en_GB' : 'fi_FI'
    var lang_label = this.$route.name === 'campaign_en' ? 'English' : 'Suomi'
    await this.getCampaign({slug:slug, lang : lang});
    if (!this.campaign) {
      this.$router.push({name : 'page-not-found'});
    }
    this.$i18n.locale = lang
    this.setLang(lang)
    localStorage.setItem('locale', lang);
    localStorage.setItem('locale_label', lang_label);
  },
  methods: {
    ...mapActions("campaign", ["getCampaign"]),
    ...mapActions("app", ["setLang"]),
    playVideo() {
      this.videoSrc = 'https://www.youtube.com/embed/9vB_EGSmWho';
      this.videoVisible = true;
    },
    formatNumber(number) {
      return number < 10 ? `0${number}` : number;
    },
    isOpen(index) {
      return this.openIndex === index;
    },
    toggleAccordion(index) {
      if (this.isOpen(index)) {
        this.openIndex = null;
      } else {
        this.openIndex = index;
      }
    },
    lang() {return this.$route.name === 'campaign_en' ? 'en' : 'fi'},
    data_check(section_key, key_array) {
      var self = this, total = 0
      if (section_key && this.campaign && this.sections.hasOwnProperty(section_key) && key_array.length > 0) {
        var key = this.sections[section_key];
        for (var l = 0; l < key_array.length; l++) {
          var KEY = [key_array[l]][0].toString()
          if (self.campaign[key][KEY] && self.campaign[key][KEY][self.lang()]) {
            total++
          }
        }
      } else {
        return false
      }
      return key_array.length === total;
    },
    data_get(section_key, KEY) {
      var key = this.sections[section_key];
      return this.campaign[key][KEY][this.lang()]
    },
    dataSetStyle(imageUrl) {
      return {
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url('${this.campaign.image_base_path}${imageUrl}')`
      }
    },
    dataSetImage(imageUrl) {
      return this.campaign.image_base_path + imageUrl;
    }
  }
}
</script>

<style scoped>
.section-space { margin: 5rem 0; }
.section {
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.top-section-left-inner {
  width: min(60%, 1200px/2);
  padding-right: 30px;
}

.bg-old-gold {
  background: linear-gradient(to right, #FFFFFF, rgba(218, 157, 38, 0.1))
}

.landing-page-logo {
  max-width: 250px;
  max-height: 150px;
  margin: 1rem 0;
}
.landing-page-logo img {
  max-width: 250px;
  height: auto;
}

.landing-page-title {
  color: #333333;
  font-size: 50px;
  font-weight: 500;
  line-height: 60px;
}

.landing-page-title-default {
  color: #333333;
  font-size: 40px;
  font-weight: 500;
  line-height: 55px;
}

.landing-page-right-image img {
  height: 700px;
  object-fit: cover;
  object-position: center center;
  vertical-align: middle;
  display: inline-block;
}

/*--Section Two stats--*/

.stats {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

.stat {
  flex: 1 1 230px;
  margin: 0.5rem;
  padding: 0.5rem;
}

.stat img{
  max-width: 250px;
  max-height: 150px;
  height: auto;
}

.stat h3 {
  font-size: 2em;
  color: #333;
  margin: 20px 0;
}

.stat p {
  font-size: 1.1em;
  color: #666;
  margin: 5px 0 0;
}

/**
*-- Another State
*-- START
*/
.another-stats { display: flex; justify-content: center; gap: 20px; flex-wrap: wrap; }
.another-stat { flex: 1 1 30%; margin: 0.5rem; padding: 0.5rem; text-decoration: none; position: relative; overflow: hidden; }
.image-container { position: relative; }
.another-stat img { width: 100%; height: auto; display: block; }
.another-stat h3 { position: absolute; bottom: 10px; font-size: 2em; color: #fff; margin: 0; background-color: rgba(0, 0, 0, 0.5); padding: 5px 10px; width: 100%; height: 100px; }

.another-stat:hover { background-color: #f0f0f0; }

/* Responsive adjustments */
@media (max-width: 1200px) {
  .another-stat { flex: 1 1 30%; }
  .another-stat h3 { font-size: 1.8em; padding: 4px 8px; }
}

@media (max-width: 992px) {
  .another-stat { flex: 1 1 45%; }
  .another-stat h3 { font-size: 1.6em; padding: 3px 6px;max-height: 100px; height: auto;}
}

@media (max-width: 768px) {
  .another-stat { flex: 1 1 100%; }
  .another-stat h3 { font-size: 1.4em; padding: 3px 6px; }
}

@media (max-width: 576px) {
  .another-stats { flex-direction: column; align-items: center;}
  .another-stat { flex: 1 1 100%; }
  .another-stat h3 { font-size: 1.2em; padding: 2px 4px; }
}
/**
*-- Another State
*-- STOP
*/



/*-Third Section-*/
.section .left, .section .right {
  flex: 1 1 50%;
}

.section-4-img-container img {
  object-fit: cover;
  border-radius: 7px 7px 7px 7px;
  height: 625px;
}

@media (max-width: 768px) {
  .section .left, .section .right {
    flex: 1 1 100%;
  }
}

.section-background-image {
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

.section-border-radius {
  border-radius: 0.5rem;
}

.font-size-44 {
  font-size: 44px;
}

.landing-page-button-primary {
  display: inline-flex;
  align-items: center;
  background-color: #fff;
  color: rgb(218, 157, 38);
  padding: 10px 40px;
  border: 1px solid rgb(255, 255, 255);
  border-radius: 25px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;
  text-decoration: none;
}

.landing-page-button-primary svg {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  fill: currentColor;
}

.landing-page-button-primary:focus,
.landing-page-button-secondary:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(218, 157, 38, 0.5);
}

.landing-page-button-secondary {
  display: inline-flex;
  align-items: center;
  background-color: transparent;
  color: rgb(255, 255, 255);
  padding: 10px 40px;
  border: 1px solid rgb(255, 255, 255);
  border-radius: 25px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;
  text-decoration: none;
}

.button-container {
  gap: 20px;
  margin: 20px 0;
}
.landing-page-title {
  color: #333;
  font-family: "Space Grotesk", Sans-serif;
  font-size: 40px;
  font-weight: 500;
  line-height: 55px;
}
.w-70 {
  width: 70%;
}

.section-image-container img{
  height: 900px;
  object-fit: cover;
  object-position: center center;
}
.bg-off-white {background: #f8f8f8}
.lp-widget-container {
  background: #FFFFFF;
  width: 73px;
  height: 73px;
  display: flex;
  justify-content: center;
  border-radius: 50%;
}
.lp-widget-container img {
  vertical-align: middle;
  display: inline-block;
  max-width: 45px;
  height: fit-content;
  margin-top: 0.9rem;
}
p {
  margin-block-start: 0;
  margin-block-end: .9rem;
}
/*-- Video Container--*/
/* styles.css */

.thumbnail-container {
  position: relative;
  cursor: pointer;
  height: 500px;
}

.thumbnail-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 50px;
  color: white;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-container {
  width: 100%;
  height: 500px;
}

.iframe-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  height: 100%;
  overflow: hidden;
}

.iframe-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/*---Blogs----*/
.blog-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.blog-item {
  flex: 1 1 calc(33.333% - 20px);
  padding: 20px 0;
  text-align: left;
  box-sizing: border-box;
}

.blog-item.no-padding {
  padding: 0;
}

.blog-number {
  font-size: 60px;
  color: #000;
  margin-bottom: 10px;
}

.blog-description {
  font-size: 16px;
  color: #333;
}

/* Responsive styles */
@media (max-width: 1200px) {
  .blog-item {
    flex: 1 1 calc(50% - 20px);
  }
}

@media (max-width: 768px) {
  .blog-item {
    flex: 1 1 100%;
  }
}

/*---Tab with plus icons*/
.tabs-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.tabs-container .tabs {
  width: 100%;
}

.tabs-container .tabs-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.tabs-container .tab {
  width: 100%;
  text-align: center;
  padding: 10px;
  cursor: pointer;
  border-bottom: 1px solid #ccc;
}

.tabs-container .active {
  font-weight: bold;
}

.tabs-container .tab-content {
  width: 100%;
}

.tabs-container .tab-content > div {
  display: none;
  padding: 10px;
}

.tabs-container .tab-content > div:first-child {
  display: block;
}

.tabs-container .description {
  margin-top: 10px;
}

/*---- Accordin ----*/
.card.accordion-card {
  border-radius: 0 !important;
  border-top-color: #000000;
}
.card.accordion-card > header {
  background: #fff !important;
  border-top: 0;
}
.accordion-header.card-header {
  border-bottom: 1px solid #000000;
}
.accordion-header {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #0a0a0a;
  font-weight: bold;
  border-radius: 0 !important;
  background: #fff !important;
}

.accordion-icon {
  font-size: 1.25rem;
  line-height: 1;
}

.b-card-header:focus {
  outline: none;
}
</style>